import {
  CommonWidthEnum,
  commonWidthValues,
} from 'common/constants/commonWidth'
import {
  backgroundColorCss,
  mobileBackgroundColorCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface SectionContainerProps {
  width: string | undefined
  backgroundColor?: string
  mobileBackgroundColor?: string
}

const SectionContainerUi = styled.div<SectionContainerProps>`
  max-width: ${p => p.width || commonWidthValues[CommonWidthEnum.fullPage]};
  width: 100%;
  margin: auto;
  ${backgroundColorCss}
  ${p => p.theme.phone} {
    max-width: initial;
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      max-width: initial;
      ${mobileBackgroundColorCss}
    `}
`

export default SectionContainerUi
